<template lang="pug">
.page-redirect
    el-form-item.link
        el-radio-group(v-model="linkType" size="mini")
            el-radio-button(v-if="postLinksFeatureEnabled && categories.length" name="type" label="post") {{ $t('Post') }}
            el-radio-button(name="type" label="internal") {{ $t('Menu item') }}
            el-radio-button(name="type" label="external") {{ $t('External') }}
            el-radio-button(name="type" label="mailto") {{ $t('Email') }}
            el-radio-button(name="type" label="tel") {{ $t('Phone') }}
        transition(name="slide-vertical")
            .internal.flex-row(v-if="linkType === 'internal'")
                Treeselect(
                    v-model="linkMenuItem"
                    :placeholder="$t('Select a menu item ...')"
                    :multiple="false"
                    :options="linkPageOptions"
                    :default-expand-level="Infinity"
                    :close-on-select="true"
                    :open-on-focus="true"
                    :searchable="true"
                    :normalizer="node => ({ label: node.title, ...node })"
                    :clearable="true"
                    :always-open="false"
                )
                    label(
                        slot="option-label"
                        slot-scope="{ node }"
                        :class="{ optgroup: node.raw.optgroup }"
                    ) {{ node.raw.title }}
                    div(
                        slot="value-label"
                        slot-scope="{ node }"
                        :class="{ optgroup: node.raw.optgroup }"
                    ) {{ node.raw.title }}
                el-input.anchor-input(
                    type="text"
                    prefix-icon="fas el-icon-fa-hashtag"
                    v-model="linkAnchor"
                    :placeholder="$t('Anchor')"
                )
            .post.flex-row(v-else-if="linkType === 'post'")
                el-select.is-full-width(
                    v-model="linkPage"
                    :placeholder="$t('Find a post ...')"
                    filterable
                    remote
                    clearable
                    :remote-method="findPost"
                    :loading="post.loading"
                )
                    el-option(
                        v-for="option in post.items"
                        :key="option.id"
                        :label="option.title"
                        :value="option.id"
                    )
                        PostOptionPreview(:post="option")
                el-input.anchor-input(
                    type="text"
                    prefix-icon="fas el-icon-fa-hashtag"
                    v-model="linkAnchor"
                    :placeholder="$t('Anchor')"
                )
            .external(v-else)
                el-input(type="text" v-model="linkHref" :placeholder="linkHrefPlaceholder")
                el-checkbox(v-if="linkType === 'external'" v-model="linkTarget") {{ $t('Open link in new window/tab') }}
</template>

<i18n>
{
    "de": {
        "Target": "Ziel",
        "Select a menu item ...": "Menüpunkt auswählen ...",
        "Find a post ...": "Beitrag suchen ...",
        "Email": "E-Mail",
        "Phone number": "Telefon",
        "Internal": "Intern",
        "Menu item": "Menüpunkt",
        "External": "Externe URL",
        "Post": "Beitrag",
        "Phone": "Telefon",
        "Download": "Download",
        "Anchor": "Anker",
        "Open link in new window/tab": "Link in einem neuen Fenster/Tab öffnen"
    }
}
</i18n>

<script>

import _ from 'lodash'

import NestedSet from '@/nested-set-lib'
// import router from '@/router'

import Treeselect from '@riophae/vue-treeselect'
import PostOptionPreview from './Sections/Partials/PostOptionPreview.vue'
import { useSetupStore, usePageStore } from '@/stores'

export default {
    name: 'Redirect',
    props: {
        // module: {
        //     type: String,
        //     required: true
        // },
        // page: {
        //     type: Object,
        //     required: false
        // },
        // i: {
        //     type: Number
        // }
    },
    data() {
        return {
            post: {
                loading: false,
                items: []
            }
        };
    },
    components: {
        Treeselect,
        PostOptionPreview
    },
    computed: {
        pageStore() {
            return usePageStore()
        },
        form() {
            return this.pageStore.form
        },
        options() {
            return this.pageStore.options
        },
        postLinksFeatureEnabled() {
            let features = _.get(this.activeCms, 'config.template.features') || [];
            return !!features.find(el => el === 'menu-redirect:post-links');
        },
        categories() {
            return _.get(this.activeCms, 'config.template.categories') || [];
        },
        validationPath() {
            // TODO:
            // define validation path by config and module
            return undefined
        },
        // currentItem() {
        //     const menuItems = _.get(this.form, 'menuItems', [])
        //     if (this.i !== null) return menuItems[this.i]
        //     else return null
        // },
        linkType: {
            get() {
                return _.get(this.form, 'redirect.type')
            },
            set(value) {
                this.pageStore.setFormRedirectField({ value, field: 'type' })
            }
        },
        linkHref: {
            get() {
                return _.get(this.form, 'redirect.href')
            },
            set(value) {
                this.pageStore.setFormRedirectField({ value, field: 'href' })
            }
        },
        linkAnchor: {
            get() {
                return _.get(this.form, 'redirect.anchor')
            },
            set(value) {
                this.pageStore.setFormRedirectField({ value, field: 'anchor' })
            }
        },
        linkHrefPlaceholder() {
            let placeholder

            switch (this.linkType) {
                case 'internal':
                    placeholder = this.$t('Select a menu item ...')
                    break;

                case 'post':
                    placeholder = this.$t('Find a post ...')
                    break;

                case 'external':
                    placeholder = this.$t('Target')
                    break;

                case 'mailto':
                    placeholder = this.$t('Email')
                    break;

                case 'tel':
                    placeholder = this.$t('Phone number')
                    break;
            }

            return placeholder
        },
        linkTarget: {
            get() {
                return _.get(this.form, 'redirect.target') === '_blank'
            },
            set(bool) {
                let value = '_self'
                if (bool === true) value = '_blank'
                this.pageStore.setFormRedirectField({ value, field: 'target' })
            }
        },
        linkMenuItem: {
            get() {
                return _.get(this.form, 'redirect.menuItem.id')
            },
            set(id) {
                let value = null
                if (id) {
                    value = { id }
                }
                this.pageStore.setFormRedirectField({ value, field: 'menuItem' })
            },
        },
        linkPageOptions() {
            let menus = _.get(this.activeCms, 'config.template.menus', [])
            menus = _.cloneDeep(menus).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))

            const menuOptions = _.get(this.options, 'menu.items') || []
            const visibleOptgroups = menuOptions.filter(el => el.menuItems.length).length > 1

            let tree = []
            menus.forEach(menu => {
                if (menu.key === this.form.key) {
                    let items = _.get(this.form, 'menuItems', [])

                    if (items.length) {
                        const optgroup = {
                            id: `optgroup-${this.form.id}`,
                            title: this.form.name,
                            isDisabled: true,
                            optgroup: true,
                        }

                        items = _.cloneDeep(items)
                        items.forEach(item => {
                            if (item.deleted === true) item.isDisabled = true
                            // check if same as current item
                            // if (this.currentItem !== null && this.currentItem.id === item.id) item.isDisabled = true
                        })

                        if (visibleOptgroups) tree.push(optgroup)
                        tree = [...tree, ...NestedSet.createTree(items)]
                    }
                } else {
                    const menuOption = _.find(menuOptions, { key: menu.key })
                    let items = _.get(menuOption, 'menuItems', [])

                    if (items.length) {
                        items = _.cloneDeep(items)

                        const optgroup = {
                            id: `optgroup-${menuOption.id}`,
                            title: menuOption.name,
                            isDisabled: true,
                            optgroup: true,
                        }

                        if (visibleOptgroups) tree.push(optgroup)
                        tree = [...tree, ...NestedSet.createTree(items)]
                    }
                }
            })

            return tree
        },
        linkPage: {
            get() {
                return _.get(this.form, 'redirect.page.title')
            },
            set(id) {
                var item = _.find(this.post.items, { id: id });

                let value = null;
                if (id) {
                    value = {
                        id,
                        title: item.title
                    };
                }
                this.pageStore.setFormRedirectField({ value, field: 'page' })
            }
        },
        // form() {
        //     return store.getters[`${this.module}/form`]
        // },
        // options() {
        //     return store.getters[`${this.module}/options`]
        // },
        activeCms() {
            return useSetupStore().activeCms;
        },
    },
    methods: {
        findPost(query = '') {
            let items = []

            this.post.loading = true
            this.pageStore.findCategoryPosts(query)
                .then(data => {
                    items = [...items, ...data.items]
                    this.post.items = _.orderBy(_.uniqBy(items, 'id'), 'created_at', 'desc')
                })
                .finally(() => this.post.loading = false)
        },
    },
    mounted() {
        if (!this.linkType) {
            this.pageStore.setFormRedirectField({ value: 'internal', field: 'type' })
        }
    }
}
</script>

<style lang="sass" scoped>
.page-redirect .el-radio-group
    margin-bottom: 10px
.link
    margin-bottom: 0
.anchor-input
    width: 180px
    min-width: 180px
</style>
